export default __webpack_public_path__ + "static/watch-now-page-hero-ed0efff50e2a853825521122ced3bb30.png";